import { useContext } from "react";
import {
  StateContext,
  StateDispatchContext,
  RESET_PERSONAL_NUMBER,
  SET_PERSONAL_NUMBER,
  SET_LIME_DATA,
  SET_ERROR,
  SET_API_VALUES,
  SET_SUCCESS,
  SET_RECAPTCH_DATA,
  SET_TOKEN,
} from "../State";

export function useDispatch() {
  const dispatch = useContext(StateDispatchContext);

  const resetPersonalNumber = () => dispatch({ type: RESET_PERSONAL_NUMBER });
  const setPersonalNumber = (personalNumber) =>
    dispatch({ type: SET_PERSONAL_NUMBER, personalNumber });
  const setLimeData = (lime) => dispatch({ type: SET_LIME_DATA, lime });
  const setError = (error) => dispatch({ type: SET_ERROR, error });
  const setSuccess = (successType) =>
    dispatch({ type: SET_SUCCESS, successType });
  const setRecapatchaData = (siteKey, action) =>
    dispatch({ type: SET_RECAPTCH_DATA, siteKey, action });
  const setToken = (token) => dispatch({ type: SET_TOKEN, token });
  const setApiValues = (
    lime,
    formType,
    hasPhoneAdvising,
    hasVab,
    hasAfterRegistration,
    customerInfo,
    reportReceived,
    hasVabAfterRegistration,
    vabCustomerInfo,
    hasVabPhoneAdvising,
    hasAbsence
  ) =>
    dispatch({
      type: SET_API_VALUES,
      lime,
      formType,
      hasPhoneAdvising,
      hasVab,
      hasAfterRegistration,
      customerInfo,
      reportReceived,
      hasVabAfterRegistration,
      vabCustomerInfo,
      hasVabPhoneAdvising,
      hasAbsence,
    });

  return {
    resetPersonalNumber,
    setPersonalNumber,
    setLimeData,
    setError,
    setApiValues,
    setSuccess,
    setRecapatchaData,
    setToken,
  };
}

export function useState() {
  const state = useContext(StateContext);

  return state;
}
